export const pranayamaSteps = [
  {
    title: "Preparation",
    steps: [
      "Find a Comfortable Position: Sit in a comfortable seated position with your spine erect. You can sit cross-legged on the floor or on a chair with your feet flat.",
      "Relax: Close your eyes and take a few moments to relax and settle into your breath.",
    ],
  },
  {
    title: "Ujjayi Pranayama (Ocean Breath)",
    steps: [
      "Inhale: Breathe in through your nose, gently constricting the back of your throat to create a soft, ocean-like sound.",
      "Exhale: Breathe out through your nose with the same gentle constriction of the throat, maintaining the sound.",
      "Duration: Start with 3-5 minutes. Increase the duration as you become more comfortable.",
    ],
  },
  {
    title: "Nadi Shodhana (Alternate Nostril Breathing)",
    steps: [
      "Preparation: Use your right thumb to close off your right nostril and use your ring finger to close off your left nostril.",
      "Inhale: Close the right nostril with your thumb and inhale deeply through the left nostril.",
      "Switch: Close the left nostril with your ring finger, release the right nostril, and exhale through the right nostril.",
      "Inhale: Inhale through the right nostril.",
      "Switch: Close the right nostril, release the left nostril, and exhale through the left nostril.",
      "Duration: Practice for 5-10 minutes, gradually increasing as you feel more comfortable.",
    ],
  },
  {
    title: "Kapalabhati (Skull Shining Breath)",
    steps: [
      "Inhale: Take a deep breath in through your nose, expanding your abdomen.",
      "Exhale: Forcefully exhale through your nose while pulling your abdomen in towards your spine.",
      "Inhale: Allow your breath to return passively.",
      "Duration: Start with 30-60 seconds. Gradually increase as you get more accustomed.",
    ],
  },
  {
    title: "Bhramari (Bee Breath)",
    steps: [
      "Inhale: Take a deep breath in through your nose.",
      "Exhale: Close your ears with your index fingers, and hum like a bee while exhaling, feeling the vibration in your head and throat.",
      "Duration: Practice for 3-5 minutes.",
    ],
  },
  {
    title: "Cooling Down",
    steps: [
      "Gentle Breath: Conclude your practice with a few minutes of gentle, natural breathing to return to a calm state.",
      "Relaxation: Sit quietly for a few moments, observing the effects of the practice.",
    ],
  },
];

export const GEMINI_API_KEY = process.env.REACT_APP_GEMINIAPI;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;